import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=1a4c4f3e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4c4f3e')) {
      api.createRecord('1a4c4f3e', component.options)
    } else {
      api.reload('1a4c4f3e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=1a4c4f3e&", function () {
      api.rerender('1a4c4f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YZ7ZmAHAfl96/JS/comp/ErrorMessage.vue"
export default component.exports